import { campusRecruitments, companyMap, historyList, salesPersons, socialRecruitments } from './models'
import { companyTemplate, historyTemplate, salesTemplate } from './templates';

$(function () {
    var snapScroller;
    if (!window.mobileCheck()) {
        snapScroller = $('#document').snapScroll({
            onArrive: function (prevPoint, currentPoint) {

            },
            onLeave: function (currentPoint, nextPoint) {
            }
        });
    }

    /* 链接跳转显示区域公司 */
    let areaOnce = '';
    let aboutItems;
    let joinItems;
    let contactItems;
    $('#home .section-desc__link')
        .on('click', function () {
            $('#home .section-desc__link').removeClass('section-desc__link--active')
            $(this).addClass('section-desc__link--active')

            let about
            let join
            let contact
            switch (this.dataset.link) {
                case '0':
                    contact = $('[data-contact-item]').detach();
                    join = $('[data-join-item]').detach();
                    $(aboutItems).insertBefore($('#footer-section'))
                    if ($(this).data('co-init') === 'init') {
                        $(this).data('co-init', '')
                    } else {
                        setTimeout(() => {
                            if (window.mobileCheck()) {
                                $('#document').animate({ scrollTop: $('#document').scrollTop() + $('#development-path').offset().top })
                            } else {
                                snapScroller?.scrollToPoint(1)
                            }
                        })
                    }
                    break;
                case '1':
                    about = $('[data-about-item]').detach();
                    contact = $('[data-contact-item]').detach();
                    $(joinItems).insertBefore($('#footer-section'))
                    setTimeout(() => {
                        if (window.mobileCheck()) {
                            $('#document').animate({ scrollTop: $('#document').scrollTop() + $('#join-us').offset().top })
                        } else {
                            snapScroller?.scrollToPoint(1)
                        }
                    })
                    break;
                case '2':
                    about = $('[data-about-item]').detach();
                    join = $('[data-join-item]').detach();
                    $(contactItems).insertBefore($('#footer-section'))
                    if (areaOnce && companyMap[areaOnce]) {
                        $(`[data-area="${areaOnce}"]`).trigger('click')
                    } else {
                        $('[data-area="south-china"]').trigger('click')
                    }
                    areaOnce = '';
                    setTimeout(() => {
                        $('#document').animate({ scrollTop: $('#document').scrollTop() + $('#contact-us').offset().top })

                    })
                    break;
                default:
            }
            if (about?.length) {
                aboutItems = about;
            }
            if (join?.length) {
                joinItems = join;
            }
            if (contact?.length) {
                contactItems = contact;
            }
            snapScroller?.disable();

            if (this.dataset.link !== '2' && !window.mobileCheck()) {
                snapScroller = $('#document').snapScroll({
                    onArrive: function (prevPoint, currentPoint) {

                    },
                    onLeave: function (currentPoint, nextPoint) {
                    }
                });
            }
            // 切换link 的时候调一下多语言 --初始化的时候偶现无国际化的情况
            $('body').i18n()
        })
    setTimeout(() => {
        // $('[data-link=2]').trigger('click')
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('area')) {
            areaOnce = urlParams.get('area')
            $('#home .section-desc__link:last').trigger('click')
        } else {
            $('#home .section-desc__link:first').trigger('click')
        }
    });

    const renderRecruitments = (type: string) => {
    $('#join-us-right-content-pagination').pagination({
        dataSource: type === 'social' ? socialRecruitments : campusRecruitments,
        pageSize: 5,
        showPrevious: false,
        showNext: false,
        callback: function (data: any[], pagination) {
            // template method of yourself
            console.log(data);
            console.log(pagination);
            const htmlList = data.map((o, i) => {
                return `
            <div class="job-link" data-index="${(pagination.pageNumber - 1) * pagination.pageSize + i}"><i class="fa fa-angle-right"></i><a data-i18n="${o.prefix}title"></a></div>
            `
            })
            $('.join-us__right-links').html(htmlList.join(''))
            $('.join-us__right-links').i18n()
        }
    })
    }
    renderRecruitments('social');
    $(document).on('click', '.job-link', function (e) {
        $('.job-link').removeClass('active')
        $(this).addClass('active')
        $('.join-us__title').data('i18n', socialRecruitments[this.dataset.index].prefix + 'title')
        $('#job-responsibilities').data('i18n', socialRecruitments[this.dataset.index].prefix + 'responsibilities')
        $('#job-requirements').data('i18n', socialRecruitments[this.dataset.index].prefix + 'requirements')
        $(`.join-us__left`).i18n()
    })
    $('.job-link:first').trigger('click')

    $('[data-right-header]').on('click', function () {
        renderRecruitments(this.dataset.type);
        $('[data-right-header]').removeClass('active')
        $(this).addClass('active')
    })

    $('.contact-us__header-item').on('click', function () {
        $('.contact-us__header-item').removeClass('active')
        $(this).addClass('active')


        $('.contact-us__content').html(companyMap[this.dataset.area].map(o => companyTemplate(o)).join(''));
        $('.contact-us__content').i18n()
    })

    $(function () {

        var options = {
            horizontal: 1,
            itemNav: 'basic',
            speed: 300,
            moveBy: 1000,
            mouseDragging: 1,
            touchDragging: 1,
            startAt: 0,
            activeClass:   'active',
            activateOn: 'click',
        }

        $('#develop-sly-inner').append(historyList.map(historyTemplate).join(''))

        const devFrame = $('.develop-sly').sly({
            ...options,
            next: $('.develop-sly__forward'),
            prev: $('.develop-sly__backward'),
        }, {
            active: function (...args) {
                this.toCenter(args[1])
            },
        });
        /* 设置历程左右按钮 */
        // setTimeout(() => {
        //     const normalImg = $('.develop-sly__item:not(.active) img:first')
        //     const buttons = $('button[data-dev-sly-button]')
        //
        //     buttons.css('top', normalImg.position().top + normalImg.outerHeight() / 2 - buttons.outerHeight() / 2 + 'px')
        // }, 1e3);

        $('#develop-sly-inner').append('<div class="develop-sly__dash-line"></div>')
        $('.develop-sly__dash-line').width($('#develop-sly-inner').outerWidth())

        $('#gold-medal-content-inner').append(salesPersons.map(salesTemplate).join(''))
        const goldFrame = $('.gold-medal-content__sly').sly(options, {
            active: function (...args) {
                console.log(args);
                this.toStart(args[1])
                const sale = salesPersons[args[1]]
                $(`.gold-medal-content__header .gold-medal-content__title`).text(sale.cnName)
                $(`.gold-medal-content__header .gold-medal-content__sub-title`).text( sale.enName)
                $('#sales-entry-time').text(sale.entryTime)
                // $('.gold-medal-content__job-title').attr('data-i18n', sale.job)
                // $('#sales-company').attr('data-i18n', sale.company)
                // $('#sales-desc').attr('data-i18n', sale.desc)
                // $('#sales-motto').attr('data-i18n', sale.motto)
                $('.gold-medal-content__job-title').data('i18n', sale.job)
                $('#sales-company').data('i18n', sale.company)
                $('#sales-desc').data('i18n', sale.desc)
                $('#sales-motto').data('i18n', sale.motto)
                $(`#sales-big-pic`).attr('src', sale.imgLg)
                $('.gold-medal-content__info').i18n()
            },
            moveEnd: function (...args) {
                const reg = /translateX\((.+?)px\)/
                const container = $(this.frame).children()[0]
                console.log(container.style.transform);
                const translateX = +container.style.transform.match(reg)[1];
                if (translateX !== 0) {
                    $(this.frame).addClass('gold-medal-content__sly--left-shadow')
                } else {
                    $(this.frame).removeClass('gold-medal-content__sly--left-shadow')
                }
                if (translateX + $(container).outerWidth() > $(this.frame).outerWidth()) {
                    $(this.frame).addClass('gold-medal-content__sly--right-shadow')
                } else {
                    $(this.frame).removeClass('gold-medal-content__sly--right-shadow')
                }
            }
        });

        ;(function () {
            const point = $('.develop-sly__point:first')

            $('.develop-sly__dash-line').css('top', `${point.position().top + point.outerHeight() / 2 - .5}px`)
            $(window).on('resize', function () {
                $('.develop-sly__dash-line').css('top', `${point.position().top + point.outerHeight() / 2 - .5}px`)
            })
        })();
    })
})